import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';

export class PostSendRecurrentNoteCommand extends IRequestCommand<
  IPostSendRecurrentNoteResponse,
  ErrorDetails,
  IPostSendRecurrentNote
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'carriers/recurringTrip/{recurringId}/updateNote';

  constructor(recurringId: number, note: string) {
    super();
    this._commandUrl = this._commandUrl.replace(
      '{recurringId}',
      recurringId.toString()
    );
    this._commandUrl += `?note=${encodeURIComponent(note)}`;
  }
}

export interface IPostSendRecurrentNote extends ICommandParameters {
  note?: string;
}

export interface IPostSendRecurrentNoteResponse extends ICommandResponse {}
